import React from "react";
import { Input } from "@ui-kitten/components";

const BaseInput = ({ value, setValue, placeholder = "Place your Text", size = "large", ...props }) => {
  // console.log({ props });
  return <Input placeholder={placeholder} value={value} onChangeText={(nextValue) => setValue(nextValue)} size={size} {...props} />;
};
export default BaseInput;
